import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import type { ITextSnippetDTO } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TextSnippetProvider } from '../../provider/text-snippet.provider';

@UntilDestroy()
@Component({
    selector: 'lib-text-snippets-list-dialog-component',
    templateUrl: 'text-snippets-list-dialog.component.html',
    styleUrls: ['text-snippets-list-dialog.component.scss'],
})
export class TextSnippetsListDialogComponent implements OnInit {
    public data: ITextSnippetDTO[] = [];

    public selectedRowTextSnippet: ITextSnippetDTO | undefined;

    public columnsToDisplay = ['description', 'title', 'button'];

    @Output() insertTextSnippetClicked: EventEmitter<ITextSnippetDTO> = new EventEmitter<ITextSnippetDTO>();

    constructor(private readonly textSnippetProvider: TextSnippetProvider) {}

    ngOnInit(): void {
        this.textSnippetProvider
            .getAllTextSnippets$()
            .pipe(untilDestroyed(this))
            .subscribe((textSnippetsList) => {
                this.data = textSnippetsList;
            });
        this.textSnippetProvider.dispatchTextSnippetsList();
    }

    public onInsertTextSnippetClicked(selectedTextSnippet: ITextSnippetDTO): void {
        this.selectedRowTextSnippet = selectedTextSnippet;
        this.insertTextSnippetClicked.emit(selectedTextSnippet);
    }
}
